<template>
    <b-container  class="big-profile p-0" fluid>
      <b-row no-gutters>
        <b-col cols="2"
          ><div >
            <b-img
              class="bigProfileImg"
              :src="userInfo.profile_picture || defaultProfileImage"
              alt
            /></div
        ></b-col>
        <b-col cols="8">
          <div class="big-page-paraghraph">
            <h2 class="bigName">
              {{
                `${userInfo.first_name || "Name"} ${
                  userInfo.last_name || "Surname"
                }`
              }}
            </h2>
            <p class="big-work-info">{{ userInfo.job_title || "No Job" }}</p>
            <router-link
              :to="{
                name: 'companyProfile',
                params: { companyId: getId(userInfo.company) },
              }"
            >
              <p class="big-profile-text">
                {{ userInfo.company_name || "No Company" }}
              </p>
            </router-link>
          </div></b-col
        >

        <b-col cols="2"
          ><UserNetwork
            :customer-id="$route.params.customerId"
            class="user-network" />
              <b-button class="go-to-edit-profile-btn" @click="()=>{$router.push({
          name: 'userSettings',
        })}">
          edit
        </b-button></b-col
      ></b-row>
      <b-row
        ><b-col>
          <div class="segments-div">
            <b-badge
              v-for="segment in userInfo.tags"
              :key="segment.id"
              class="segment"
              variant="dark"
              >{{ segment.name || "No Segment" }}
            </b-badge>
            <router-link :to="{ name: 'userSettings' }">
              <b-badge class="btn-add-more" variant="light">add more</b-badge>
            </router-link>
          </div></b-col
        ></b-row
      >
    </b-container>

</template>

<script>
import { mapGetters } from 'vuex';
import UserNetwork from '../UserNetwork.vue';
import getIDfromURL from '../../utils/getIDfromURL';
import defaultProfileImage from '../../assets/default-user-profile-image.png';

export default {
  name: 'MobileProfile',
  components: {
    UserNetwork,
  },
  props: {
    isOwner: {
      type: Boolean,
      default: true,
    },
    otherUserInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultProfileImage,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
    }),
  },
  methods: {
    getId(url) {
      return getIDfromURL(url);
    },
  },
};
</script>

<style scoped>
.segment {
  margin: 5px;
  padding: 4px 8px;
  background-color: #aaaaaa;
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: normal;
  font-family: Arial;
  text-align: left;
  color: white;
  font-weight: normal;
  border-radius: 0 10px 10px 10px;
}
.segments-div {
  padding: 2px 7px;
  text-align: left;
  width: 100%;
  border-top: 1px solid #ebebeb;
}

.btn-add-more {
  font-size: 12px;
  padding: 4px 8px;
  user-select: none;
  margin: 7px 7px 7px 0px;
  color: #bd9d5f;
  background: #ebebeb;
  box-shadow: none;
  border-radius: 0 10px 10px 10px;
  font-weight: normal;
}

.bigProfileImg {
  border-radius: 10px 0 0 0;
  box-shadow: 0px 0px 0px 1px #dedede;
  background: white;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.big-page-paraghraph {
  margin-left: 10px;
}
.big-profile{
    background-color: #fefefe;
    border-radius: 10px;
}
.big-profile-text,
.big-work-info {
  color: gray;
  margin-bottom: -5px;
  margin-top: -4px;
  cursor: pointer;
  text-transform: capitalize;
  font-size: 12px;
  font-family: Arial;
}
.bigName {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 5px;
  text-transform: capitalize;
}
.big-profile-text {
  color: #bd9d5f;
  margin-bottom: 1px;
  font-size: 12px;
  font-family: Arial;
}
.group-contact {
  font-size: 15px;
  color: #bd9d5f;
  border: 1px solid whitesmoke;
  padding: 7px;
}
.go-to-edit-profile-btn {
  background-color: #f3f3f3;
  color: #7f7f7f;
  border-radius: 0 10px 10px 10px;
  height: 28px;
  border: none;
  font-family: Arial;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
}
.user-network {
  height: 30px;
}
</style>
